import { Button, type TPlacement, TooltipDesktop } from '@cian/ui-kit';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { useCardContext } from '@/microfrontends/listing/shared/context/CardContext';
import { cardOfferDataSelector } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { useToggleFavorite } from '../../../hooks/card/useToggleFavorite';
import { ControlWrapper } from '../components/Controls';

type FavoriteContainerProps = {
  tooltipPlacement?: TPlacement;
  isVisible?: boolean;
};

export const FavoriteContainer: FC<FavoriteContainerProps> = props => {
  const { tooltipPlacement = 'left', isVisible = false } = props;
  const cardContext = useCardContext();
  const {
    extendedProperties: { isFavorite },
  } = cardOfferDataSelector(cardContext);
  const toggleFavorite = useToggleFavorite();

  const handleToggleFavorites = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      toggleFavorite();
    },
    [toggleFavorite],
  );

  return (
    <ControlWrapper visible={isVisible || isFavorite}>
      <TooltipDesktop
        placement={tooltipPlacement}
        theme="black"
        title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      >
        <Button
          beforeIcon={
            isFavorite ? (
              <IconToggleHeartOn16 color="icon-negative-default" />
            ) : (
              <IconToggleHeartOff16 color="icon-primary-default" />
            )
          }
          data-testid="card.favorites-control"
          size="XS"
          theme="stroke_secondary"
          onClick={handleToggleFavorites}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
